import { SecondaryFontColor } from "assets/jss/material-kit-pro-react.js";
import {
  subtitleLandingMedium,
  subtitleLandingLight,
  subtitleLandingBold,
  description,
  textJustify,
} from "assets/jss/material-kit-pro-react.js";

const style = (theme) => ({
  title: {
    ...subtitleLandingMedium,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  cardTitle: {
    ...subtitleLandingBold,
  },
  description: {
    ...description,
    ...subtitleLandingLight,
    color: "white",
    fontSize: "16px",
    ...textJustify,
  },
  activityContainer: {
    margin: "20px",
    height: "100%"
  },
  activityCard: {
    display: "flex",
    flexDirection: "column"
  },
  name: {
    textTransform: "uppercase",
    color: SecondaryFontColor,
  },
  img: {
    width: "100%",
    height: "231px", // o el alto que vos quieras
    objectFit: "cover",
    objectPosition: "center",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
  }
});

export default style;
